import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import TextField from "@material-ui/core/TextField/TextField";
import Paper from "@material-ui/core/Paper/Paper";
import React from "react";
import { Api } from "../utils/api";
import withStyles from "@material-ui/core/es/styles/withStyles";
import { formatDateTime } from "../user_requests/utils/time.utils";
import Divider from "@material-ui/core/Divider";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    overflow: "scroll",
  },
  noteList: {},
  goToButton: {
    "&:disabled": {
      color: "rgba(0, 0, 0, 0.12)",
    },
  },
  notes: {
    position: "fixed",
    bottom: theme.spacing.unit * 3,
    right: theme.spacing.unit * 12,
    width: "50%",
    height: "50%",
    visibility: "hidden",
    "& visible": {
      visibility: "visible",
    },
    zIndex: 1050,
    animate: "all 1s",
  },
  note: {
    width: "100%",
  },
  addnewnote: {
    bottom: 0,
    margin: "8px",
  },
  container: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
});

const notesRoutes = {
  UserRequest: "/user_requests/",
};

class NotesBare extends React.Component {
  state = {
    note: "",
    notes: [],
  };

  constructor() {
    super();
    this.api = new Api();
    this.limit = 200;
    this.getNotes = this.getNotes.bind(this);
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  componentDidMount() {
    this.getNotes();
  }

  getNotes = () => {
    if (this.props.context_type && this.props.context_id) {
      const { context_type, context_id } = this.props;
      this.api
        .get(`/notes`, {
          context_type: context_type,
          context_id: context_id,
          limit: this.limit,
        })
        .then((response) => response.data)
        .then((notes) => this.setState({ notes }));
    }
  };

  handleKeyUp = (event) => {
    const { note } = this.state;
    if (event.key === "Enter" && note) {
      const { context_type, context_id } = this.props;
      this.setState({ note: "" });
      this.api
        .post(`/notes`, {
          note: {
            context_type,
            context_id,
            note,
          },
        })
        .then((result) => result.data)
        .then((note) =>
          this.setState({
            notes: [...this.state.notes, note],
          })
        );
    }
  };

  showNavigateTo = (note) => {
    const { context_type } = note;
    const noteRoute = notesRoutes[context_type];
    if (noteRoute) {
      return true;
    }
    return false;
  };

  navigateTo = (note) => {
    const { context_type, context_id } = note;
    const noteRoute = notesRoutes[context_type];
    if (noteRoute) {
      this.props.history.push(`${noteRoute}${context_id}`);
    }
  };

  render() {
    const { classes, open, showNavigation } = this.props;
    return (
      <Paper className={`${classes.notes} ${open ? " visible" : ""}`}>
        <div className={classes.container}>
          <AppBar position="static">
            <Toolbar>Notas</Toolbar>
          </AppBar>
          <div className={classes.root}>
            <List className={classes.noteList}>
              {this.state.notes.map((note) => (
                <>
                  <ListItem>
                    <ListItemText
                      primary={note.note}
                      secondary={
                        formatDateTime(note.created_at) +
                        " - " +
                        (note.name ? note.name : localStorage.name)
                      }
                    />
                    {showNavigation && (
                      <ListItemSecondaryAction>
                        <IconButton
                          edge="end"
                          aria-label="comments"
                          disabled={!this.showNavigateTo(note)}
                          className={classes.goToButton}
                        >
                          <ArrowForwardIcon
                            onClick={() => this.navigateTo(note)}
                          />
                        </IconButton>
                      </ListItemSecondaryAction>
                    )}
                  </ListItem>
                  <Divider variant="inset" component="li" />
                </>
              ))}
            </List>
          </div>
          <div
            class={
              this.props.context_type === "EntityNotesList" ||
              this.props.context_type === "Admin"
                ? "d-none"
                : ""
            }
          >
            <div className={classes.addnewnote}>
              <TextField
                label="Adicionar Nota"
                margin="dense"
                variant="outlined"
                fullWidth="true"
                value={this.state.note}
                onChange={this.handleInputChange}
                onKeyUp={this.handleKeyUp}
                name="note"
              />
            </div>
          </div>
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(NotesBare);
